import factory from '../../../store/factory'

export default {
  statements: factory('Statement'),
  statements_schedule: factory('StatementSchedule'),
  fundsCurrency: factory('AccountsFundsCurrencies')
}
